// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cu-4";
export var closeButton = "_cu-6";
export var dismissButton = "_cu-3";
export var editImageWithAiContainer = "_cu-8";
export var imageUploadWrapper = "_cu-7";
export var misspelledWord = "_cu-5";
export var spellCheckContainer = "_cu-2";
export var spin = "_cu-1";
export var spinning = "_cu-0";